import { useRef, useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';

import { TrashOutlineIcon } from 'Asset/icon';
import { TextRegular, TextSemiBold } from 'UiKit/typography';
import InputComponent from 'UiKit/input';
import ButtonOutline from 'UiKit/button/buttonOutline';
import ButtonSolid from 'UiKit/button/buttonSolid';
import usePostUserImage from 'Domain/brief-live/usePostUserImage';

import { NOTE_MAX_LENGTH, ICON_BTN_PROPS } from '../const';
import ImageUploadBox from '../image-upload-box';

import styles from './styles.module.css';

const ProductManualEditPanel = ({ product, onSave, onCancel, onDelete, t }) => {
  const [label, setLabel] = useState(product?.label || '');
  const [sku, setSku] = useState(product?.value || '');
  const [note, setNote] = useState(product?.note || '');
  const [imagePreview, setImagePreview] = useState(product?.image || '');
  const [imageKey, setImageKey] = useState(product?.imageKey || '');
  const fileInputRef = useRef(null);

  const { mutateAsync: uploadImage, isPending: isUploading } = usePostUserImage();

  const hasChanged =
    label !== (product?.label || '') || sku !== (product?.value || '') || note !== (product?.note || '') || imageKey !== (product?.imageKey || '');

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const { imagePath, key } = await uploadImage({ file });
    setImagePreview(imagePath);
    setImageKey(key);
  };

  return (
    <Box className={styles['product-edit__container']}>
      <Flex gap="16px">
        <ImageUploadBox imagePreview={imagePreview} fileInputRef={fileInputRef} onImageChange={handleImageChange} isUploading={isUploading} />
        <Box flex={1} display="flex" flexDirection="column" gap="8px">
          <Flex gap="8px">
            <Box flex={1}>
              <InputComponent
                placeholder={t('formTalkingPoint.productHighlightNamePlaceholderText')}
                value={label}
                onChange={(value) => setLabel(value)}
                className={styles['product-item__input-field']}
              />
            </Box>
            <Box width="200px">
              <InputComponent
                placeholder={t('formTalkingPoint.skuId')}
                value={sku}
                onChange={(value) => setSku(value)}
                className={styles['product-item__input-field']}
              />
            </Box>
          </Flex>
          <InputComponent
            placeholder={t('formTalkingPoint.notes')}
            value={note}
            onChange={(value) => setNote(value.slice(0, NOTE_MAX_LENGTH))}
            className={styles['product-item__note-field']}
          />
          <TextRegular className={styles['product-item__char-counter']}>
            ({note.length}/{NOTE_MAX_LENGTH})
          </TextRegular>
        </Box>
      </Flex>
      <Flex className={styles['product-item__edit-actions']}>
        <ButtonOutline {...ICON_BTN_PROPS} color="#dc2626" onClick={onDelete}>
          <TrashOutlineIcon width="16px" height="16px" />
        </ButtonOutline>
        <ButtonOutline height="28px" padding="6px 12px" borderRadius="var(--radius-sm)" type="button" onClick={onCancel}>
          <TextSemiBold fontSize="var(--font-body2)">{t('formTalkingPoint.cancelButton')}</TextSemiBold>
        </ButtonOutline>
        <ButtonSolid
          height="28px"
          padding="6px 12px"
          borderRadius="var(--radius-sm)"
          type="button"
          isDisabled={!label.trim() || !hasChanged || isUploading}
          onClick={() =>
            onSave({
              ...product,
              label,
              value: sku || product.value,
              note,
              imageKey: imageKey,
              image: imagePreview,
              isManual: true,
            })
          }
        >
          <TextSemiBold fontSize="var(--font-body2)" color="white">
            {t('formTalkingPoint.saveButton')}
          </TextSemiBold>
        </ButtonSolid>
      </Flex>
    </Box>
  );
};

export default ProductManualEditPanel;
